import React from 'react';
import Badge from '../ui/Badge';

function splitChips(value) {
    return (value ? String(value).split(',') : [])
        .map((v) => v.trim())
        .filter(Boolean);
}

// Renders as a compact strip directly under the incident header (Incident.jsx) — id,
// title and description already show there, so this only covers what isn't shown yet.
function METHANE({ announcement }) {
    const {
        isMajor,
        location,
        landmark,
        hazards,
        access,
        totalCasualities,
        greenCasualities,
        yellowCasualities,
        redCasualities,
        blackCasualities,
        erServicePresent,
        erServiceRequired,
        incidentTypeNames,
    } = announcement;

    const casualtyBreakdown = [
        greenCasualities ? `${greenCasualities}G` : null,
        yellowCasualities ? `${yellowCasualities}Y` : null,
        redCasualities ? `${redCasualities}R` : null,
        blackCasualities ? `${blackCasualities}B` : null,
    ].filter(Boolean).join(' · ');

    const tiles = [
        { label: 'M - Major Incident', value: isMajor ? 'Yes' : 'No' },
        { label: 'E - Exact Location', value: location || '—' },
        { label: 'Nearest Landmark', value: landmark || '—' },
        { label: 'T - Type of Hazard', chips: incidentTypeNames || [] },
        { label: 'H - Potential Hazards', chips: splitChips(hazards) },
        { label: 'A - Potential Access', chips: splitChips(access) },
        { label: 'N - Casualties', value: `${totalCasualities || 0} total${casualtyBreakdown ? ` (${casualtyBreakdown})` : ''}` },
        { label: 'E - Services Present', chips: splitChips(erServicePresent) },
        { label: 'E - Services Required', chips: splitChips(erServiceRequired) },
    ];

    return (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-y-3 gap-x-5">
            {tiles.map((tile) => (
                <div key={tile.label} className="methane-tile">
                    <span>{tile.label}</span>
                    {tile.chips ? (
                        tile.chips.length > 0 ? (
                            <div className="flex flex-wrap gap-1 mt-0.5">
                                {tile.chips.map((chip) => (
                                    <Badge key={chip} variant="blue">{chip}</Badge>
                                ))}
                            </div>
                        ) : (
                            <b>—</b>
                        )
                    ) : (
                        <b>{tile.value}</b>
                    )}
                </div>
            ))}
        </div>
    );
}

export default METHANE;
